import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPDATE_VENUE_FAIL = "UPDATE_VENUE_FAIL";

export interface UpdateVenueFailAction extends Action {
  type: typeof UPDATE_VENUE_FAIL;
  errors?: AdminErrorListResponseData;
  organization: OrganizationKeyName;
}

export const updateVenueFailAction = (
  organization: OrganizationKeyName,
  errors?: AdminErrorListResponseData
): UpdateVenueFailAction => ({
  type: UPDATE_VENUE_FAIL,
  errors,
  organization,
});
